import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../layout/table";
import ConditionalButton from "../../layout/conditional-button";
import { send as pageInfo, loading } from "../../actions/page";
import { search as getRoles } from "../../actions/roles";
import { withNavigation } from "../../utils/wrapper";

class Roles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "caption",
            index: 0,
            direction: "ASC",
            data: [],
            pages: 0,
        };
        this.props.loading(true);
    }

    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    };

    loadData = async () => {
        this.props.loading(true);

        try {
            let { page, size, order, direction, search } = this.state;

            const result = await this.props.getRoles({
                page,
                size,
                order,
                direction,
                search,
            });

            const items = Array.isArray(result?.items) ? result.items : [];
            const count = Number(result?.count ?? 0);
            const pages = items.length > 0 ? Math.ceil(count / Number(size)) : 0;

            this.setState({
                data: items,
                pages,
            });

            await this.props.pageInfo({ title: "Roles", breadcrumb: "Roles" });
        } finally {
            this.props.loading(false);
        }
    };

    get headers() {
        return [
            {
                header: "Caption",
                sortable: true,
                source: "caption",
                className: "text-muted text-small text-uppercase w-40",
                onFormat: this.onCaptionFormat,
            },
            {
                header: "Name",
                sortable: true,
                source: "name",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onNameFormat,
            },
            {
                header: "Updated",
                sortable: true,
                source: "updatedAt",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onUpdatedFormat,
            },
        ];
    }

    onCaptionFormat = (e, row) => {
        return `<a href="/dashboard/settings/roles/${row["uuid"]}">${e || ""}</a>`;
    };

    onNameFormat = (e, row) => {
        return this.onCaptionFormat(e, row);
    };

    onUpdatedFormat = (e) => {
        if (!e) return "";
        return new Date(e).toLocaleString();
    };

    onColumnClick = (e) => {
        const headers = this.headers;
        const nextIndex = headers.findIndex((item) => item.header === e.header && item.source === e.source);

        this.setState(
            {
                index: nextIndex,
                direction: this.state.index === nextIndex && this.state.direction === "DESC" ? "ASC" : "DESC",
                order: headers[nextIndex].source,
                page: 0,
            },
            this.loadData
        );
    };

    onSearch = (e) => {
        this.setState(
            {
                search: e,
                page: 0,
            },
            this.loadData
        );
    };

    onSize = (e) => {
        this.setState(
            {
                page: 0,
                size: Number(e),
            },
            this.loadData
        );
    };

    onPageChange = (e) => {
        this.setState(
            {
                page: Number(e),
            },
            this.loadData
        );
    };

    onNewClick = () => {
        this.props.navigate("add");
    };

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton
                        enabledVariant="outline-primary"
                        tooltip="Create new role"
                        display
                        enabled={true}
                        onEnabledClick={this.onNewClick}
                        icon="flash"
                    >
                        New
                    </ConditionalButton>
                </Col>

                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        sort={{ index: this.state.index, direction: this.state.direction }}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchOnEnter={true}
                        searchable={true}
                        sizable={false}
                    />
                </Col>
            </>
        );
    }
}

Roles.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default withNavigation(
    connect(mapStateToProps, { getRoles, loading, pageInfo })(Roles)
);